module.exports = __webpack_public_path__ + "img/bgc01.ee9e9cde.png";